<table *ngIf="!(isMobile | async).matches">
  <tr>
    <th>Parcela</th>
    <th>Status</th>
    <th>Data Vencimento</th>
    <th>Valor</th>
  </tr>
  <tr *ngFor="let installment of installments" (click)="handleChangeSelectedInstallment(installment)" [class.disabled]="!allowGenerateSecondCopy(installment)" [class.selected]="installment?.numeroParcela === selectedInstallment?.numeroParcela">
    <td>
      <mat-radio-button 
        [disabled]="!allowGenerateSecondCopy(installment)"
        (change)="handleChangeSelectedInstallment(installment)" 
        color="primary" 
        [checked]="installment?.numeroParcela === selectedInstallment?.numeroParcela">
        {{installment.numeroParcela}}<span class="installment-number">/{{installments?.length}}</span>
      </mat-radio-button>
    </td>
    <td>
      <span [matTooltip]="getTooltip(getInstallmentStatus(installment))"
        [ngClass]="getInstallmentStatusClass(getInstallmentStatus(installment))" class="status">
        {{getInstallmentStatus(installment)}}
      </span>
    </td>
    <td>{{installment.dataVencimento | date:'dd/MM/yyyy' }} </td>
    <td>
      <strong>{{installment.valorTotalParcela | currency:'BRL' }}</strong>
    </td>
  </tr>
</table>

<ul *ngIf="(isMobile | async).matches" class="mobile-list">
  <li *ngFor="let installment of installments" (click)="handleChangeSelectedInstallment(installment)" [class.disabled]="!allowGenerateSecondCopy(installment)" [class.selected]="installment?.numeroParcela === selectedInstallment?.numeroParcela">
    <span class="installment-index">
      <span>Parcela <span class="installment-number">{{installment.numeroParcela}}</span>/{{installments?.length}}</span>
      <button mat-icon-button #tooltip="matTooltip" (click)="tooltip.toggle(); $event.stopPropagation()" [matTooltip]="getTooltip(getInstallmentStatus(installment))"  matTooltipShowDelay="0">
        <mat-icon class="material-symbols-outlined small">help</mat-icon>
      </button>
    </span>

    <div class="action">
      <div class="due-date">
        <span class="date">{{installment.dataVencimento | date:'dd/MM/yyyy'}}</span>
        <span 
          #tooltipStatus="matTooltip" 
          (click)="tooltipStatus.toggle(); $event.stopPropagation()" 
          [matTooltip]="getTooltip(getInstallmentStatus(installment))"  
          matTooltipShowDelay="0"
          matTooltipHideDelay="1000"
          [ngClass]="getInstallmentStatusClass(getInstallmentStatus(installment))" 
          class="status">
            {{getInstallmentStatus(installment)}}
        </span>
      </div>

      <mat-radio-button
        [disabled]="!allowGenerateSecondCopy(installment)"
        (change)="handleChangeSelectedInstallment($event.value)" 
        color="primary"
        class="radio-btn"
        [checked]="installment?.numeroParcela === selectedInstallment?.numeroParcela">
      </mat-radio-button>
    </div>
    <strong class="value">{{installment.valorTotalParcela | currency:'BRL' }}</strong>
  </li>
</ul>